<template>
  <div class="sidebar" :class="{ 'sidebar-scrolled': isScrolled }">
    <ul>
      <!-- 添加 exact 属性，精确匹配 -->
      <li><router-link exact to="/">首页</router-link></li>
      <li><router-link to="/user">用户列表</router-link></li>
      <li><router-link to="/DishManagement">菜品管理</router-link></li>
      <li><router-link to="/dishgallery">菜品图库</router-link></li>
      <li><router-link to="/tongzhi">发布通知</router-link></li>
      <li><router-link to="/tupian">图片管理</router-link></li>
      <li><router-link to="/visituser">串门厨房管理</router-link></li>
      <li><router-link to="/operation-logs">菜品操作日志</router-link></li>
      <li><router-link to="/fish">爱心兑换鱼管理</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SidebarNav',
  data() {
    return {
      isDropdownOpen: false,
      isScrolled: false,
      lastScrollTop: 0
    };
  },
  mounted() {
  },
  methods: {

  }
};
</script>

<style scoped>
.sidebar {
  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 24px 0;
  width: 200px;
  min-width: 200px;
  min-height: 100vh;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.05);
  border-right: 1px solid rgba(133, 70, 133, 0.15);


}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar ul li {
  margin: 4px 12px;
}

.sidebar ul li a {
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  display: block;
  padding: 12px 16px;
  border-radius: 10px;
  color: #4a4a6a;
  transition: all 0.25s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.sidebar ul li a:hover {
  background: linear-gradient(135deg, rgba(133, 70, 133, 0.1) 0%, rgba(192, 108, 132, 0.1) 100%);
  color: #854685;
  transform: translateX(4px);
}

/* 激活状态样式 */
.sidebar ul li a.router-link-active {
  background: linear-gradient(135deg, #854685 0%, #c06c84 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(133, 70, 133, 0.25);
}

/* 精确匹配的首页激活样式（优先级更高） */
.sidebar ul li a.router-link-exact-active {
  background: linear-gradient(135deg, #854685 0%, #c06c84 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(133, 70, 133, 0.25);
}

/* 响应式适配 - 移动端 */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    min-height: auto;
    padding: 7px 0;
    position: fixed;
    left: 0;
    right: 0;
    top: 60px; /* 初始位置在顶部导航下方 */
    z-index: 100;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(133, 70, 133, 0.15);
    border-right: none;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: top 0.1s ease;
  }
  

 
  .sidebar ul {
    display: flex;
    justify-content: space-around;
    overflow-x: auto;
    padding: 0 8px;
    -webkit-overflow-scrolling: touch;
  }
  
 .sidebar ul {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.sidebar ul::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}
  
  .sidebar ul li {
    margin: 0;
    flex-shrink: 0;
  }
  
  .sidebar ul li a {
    padding: 8px 12px;
    font-size: 13px;
    white-space: nowrap;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .sidebar {
    top: 50px; /* 假设小屏手机顶部导航高度为50px */
  }
  
  .sidebar ul li a {
    padding: 6px 10px;
    font-size: 12px;
  }
}

/* 桌面端保持原有样式 */
@media (min-width: 769px) {
  .sidebar {
    top: auto;
  }
}
</style>